let Vue = require('vue');
let Promise = require('bluebird');
let moment = require('moment');

Vue.directive('datetimepicker', {
    twoWay: true,
    priority: 1000,
    params: ['time', 'default'],

    bind: function () {
        let self = this;

        $(this.el)
            .datetimepicker({
                showClear: true,
                defaultDate: this.params.default ? new Date() : null,
                locale: 'pt-BR',
                useCurrent: true,
                format: this.params.time
                    ? 'DD/MM/YYYY HH:mm:ss'
                    : 'DD/MM/YYYY'
            })
            .on('dp.change', function (event) {
                if (event.date) {
                    self.set(event.date.format('YYYY-MM-DD HH:mm:ss'));
                } else {
                    self.set(null);
                }
            });
    },
    update: function (value) {
        let dtp = $(this.el).data('DateTimePicker');
        if (value) {
            dtp.date(moment(value));
        } else {
            dtp.date(null);
        }
    },
    unbind: function () {
        let dtp = $(this.el).data('DateTimePicker');
        dtp.destroy();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/datetimepicker.js